import { useState } from "react";
import TextField from "@mui/material/TextField";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import InputAdornment from "@mui/material/InputAdornment";
import Autocomplete from "@mui/material/Autocomplete";
import { type RelevantTopicAnchorRow, type GeneralTopicItem } from "./useTaskCreation";
import { CostEstimate } from "./CostEstimate";
import type { NumericAnchorField } from "./TaskCreation";

export function AnchorTableRow(props: {
  row: RelevantTopicAnchorRow;
  index: number;
  topics: GeneralTopicItem[];
  uniqueArticles: number;
  cost: number;
  disabled: boolean;
  onSetRow: (anchorIndex: number, field: keyof RelevantTopicAnchorRow, value: string | number) => void;
}) {
  const { row, index } = props;
  const [focusedField, setFocusedField] = useState<NumericAnchorField | null>(null);

  function displayValue(field: NumericAnchorField): number | string {
    let displayValueOutcome: number | string;
    if (focusedField === field && row[field] === 0) {
      displayValueOutcome = "";
    } else {
      displayValueOutcome = row[field];
    }
    return displayValueOutcome;
  }

  function handleNumericChange(field: NumericAnchorField, rawValue: string) {
    const parsed = Number(rawValue);
    props.onSetRow(index, field, Number.isNaN(parsed) || parsed < 0 ? 0 : parsed);
  }

  const topicOptions = props.topics.map((topic) => topic.topic);

  return (
    <TableRow>
      <TableCell>
        <TextField
          value={row.text}
          size="small"
          disabled={props.disabled}
          onChange={(event) => props.onSetRow(index, "text", event.target.value)}
          fullWidth
        />
      </TableCell>
      <TableCell>
        <TextField
          type="number"
          value={displayValue("articleCount")}
          size="small"
          disabled={props.disabled}
          onChange={(event) => handleNumericChange("articleCount", event.target.value)}
          onFocus={() => setFocusedField("articleCount")}
          onBlur={() => setFocusedField(null)}
          inputProps={{ min: 1 }}
          fullWidth
        />
      </TableCell>
      <TableCell>
        <TextField
          type="number"
          value={displayValue("uniqueness")}
          size="small"
          disabled={props.disabled}
          onChange={(event) => handleNumericChange("uniqueness", event.target.value)}
          onFocus={() => setFocusedField("uniqueness")}
          onBlur={() => setFocusedField(null)}
          inputProps={{ min: 1, max: 100 }}
          InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
          fullWidth
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          freeSolo
          options={topicOptions}
          value={row.generalTopic}
          disabled={props.disabled}
          size="small"
          onChange={(_error, newValue) => {
            props.onSetRow(index, "generalTopic", newValue ?? "");
          }}
          onInputChange={(_error, newValue) => {
            props.onSetRow(index, "generalTopic", newValue);
          }}
          renderInput={(parameters) => <TextField {...parameters} />}
        />
      </TableCell>
      <TableCell align="right">{props.uniqueArticles}</TableCell>
      <TableCell align="right">{CostEstimate.formatCost(props.cost)}</TableCell>
    </TableRow>
  );
}
